import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import Switch from 'react-switch';
import { ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { loaderActions } from '../../../../_actions/loader.actions';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import FileField from '../../../../customControl/FileField';
import { patchUsersData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { getDateCombination } from '../../../commonClass/CommonFunctions';
import { fileUpload, fileUploadModal, fileUploadSeq } from '../../../commonClass/CommonInterfaceTypes';
import { ApiNotRespondMessage, imageURLpathCommon, isValidGST, isValidPAN, isValidPDFFile, onlyNumeric, validateURL } from '../../../commonClass/CommonValidation';
import { ClearLocalStorage } from '../../../commonClass/Session';
import { AffiliationsDataCollection, OtherlocationIds, SupplierProfileModal, SupplierProps } from './SupplierUtils';

function SupplierProfile(props: SupplierProps) {
    const { supplierList, locationsData, dropdownData, SupplierId, disable, editdisable, cleardisable, type, retrieveData, UserId } = props;

    const defaultFileUpload = new fileUploadModal();
    const defaultLocData: OtherlocationIds = {
        ContinentId: 0,
        CountryId: 0,
        RegionId: 0,
        StateId: 0,
    }
    const defaultAffiliationsDetails: AffiliationsDataCollection = {
        seqNo: 0,
        docName: "",
        fileName: "",
        filePath: "",
    }

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();


    const [formValue, setFormValue] = useState(new SupplierProfileModal());
    const [formError, setFormError] = useState<any>(null);
    const [locData, setLocData] = useState<OtherlocationIds>(defaultLocData);
    const [IncorprationCertificate, setIncorprationCertificate] = useState<fileUpload>(defaultFileUpload);
    const [PANNoCertificate, setPANNoCertificate] = useState<fileUpload>(defaultFileUpload);
    const [GSTNCertificate, setGSTNCertificate] = useState<fileUpload>(defaultFileUpload);
    const [AffilitionCertificate, setAffilitionCertificate] = useState<fileUpload>(defaultFileUpload);
    const [ContractFormDocPath, setContractFormDocPath] = useState<fileUpload>(defaultFileUpload);
    const [AgreementLetterDocPath, setAgreementLetterDocPath] = useState<fileUpload>(defaultFileUpload);

    const [AffiliationsDetails, setAffiliationsDetails] = useState<AffiliationsDataCollection>(defaultAffiliationsDetails);
    const [AffiliationsFileColl, setAffiliationsFileColl] = useState<fileUploadSeq[]>([]);
    const [AffiliationsDeleteFileColl, setAffiliationsDeleteFileColl] = useState<string[]>([]);

    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState(false);
    const [addbuttontext, setAddButtonText] = useState(type === "Edit" ? "Update" : "Save");

    const [disabled, setDisabled] = useState(disable);
    const [editDisabled, setEditDisabled] = useState(editdisable);

    const acceptance = ".pdf";
    const maxFileSize = 25;
    const folderPath = "CMS/SupplierDetail";

    const IncorprationCertificateRef = useRef<HTMLInputElement>(null);
    const PANNoCertificateRef = useRef<HTMLInputElement>(null);
    const GSTNCertificateRef = useRef<HTMLInputElement>(null);
    const AffilitionCertificateRef = useRef<HTMLInputElement>(null);
    const ContractFormDocPathRef = useRef<HTMLInputElement>(null);
    const AgreementLetterDocPathRef = useRef<HTMLInputElement>(null);

    //#region image upload & delete functions
    const handleimageupload = async (pathdirectory: string, filename: string, file: any) => {
        await ImageUpload(pathdirectory, filename, file);
    };

    const handleimageDelete = async (filename: string) => {
        await ImageDelete(filename);
    };
    //#endregion

    //#region retrieve data
    useEffect(() => {
        setFormValue((form) => ({
            ...form,
            SupplierId: SupplierId,
            UserId: UserId
        }));
        if (retrieveData) {
            setFormValue((form) => ({
                ...form,
                LocationId: retrieveData?.locationId,
                SupplierTypeId: retrieveData?.supplierTypeId,
                HOId: retrieveData?.hoId,
                SupplierName: retrieveData?.supplierName,
                OfficeNo: retrieveData?.officeNo,
                HouseNo: retrieveData?.houseNo,
                BuildingName: retrieveData?.buildingName,
                BuildingNo: retrieveData?.buildingNo,
                Street: retrieveData?.street,
                Locality: retrieveData?.locality,
                Landmark: retrieveData?.landmark,
                Pincode: retrieveData?.pincode,
                Website: retrieveData?.website,
                AboutSupplier: retrieveData?.aboutSupplier,
                IncorporationNo: retrieveData?.incorporationNo,
                IncorporationCertiPath: retrieveData?.incorporationCertiPath,
                PANNo: retrieveData?.panNo,
                panDocPath: retrieveData?.panDocPath,
                GSTNNo: retrieveData?.gstnNo,
                gstnDocPath: retrieveData?.gstnDocPath,
                datacollection: retrieveData?.dataCollection ? retrieveData?.dataCollection : [],
                ContractFormDocPath: retrieveData?.contractFormDocPath,
                AgreementLetterDocPath: retrieveData?.agreementLetterDocPath,
                IsOnline: retrieveData?.isOnline,
                IsOffline: retrieveData?.isOffline,
                IsActive: retrieveData?.isActive,
            }))
            setActiveId(retrieveData?.isActive);
            setLocData((loc) => ({
                ...loc,
                ContinentId: retrieveData?.continentId,
                CountryId: retrieveData?.countryId,
                RegionId: retrieveData?.regionId,
                StateId: retrieveData?.stateId
            }))
            setIncorprationCertificate((prev) => ({ ...prev, DeleteFilePath: `${imageURLpathCommon}${retrieveData?.incorporationCertiPath}` }));
            setPANNoCertificate((prev) => ({ ...prev, DeleteFilePath: `${imageURLpathCommon}${retrieveData?.panDocPath}` }));
            setGSTNCertificate((prev) => ({ ...prev, DeleteFilePath: `${imageURLpathCommon}${retrieveData?.gstnDocPath}` }));
            setContractFormDocPath((prev) => ({ ...prev, DeleteFilePath: `${imageURLpathCommon}${retrieveData?.contractFormDocPath}` }));
            setAgreementLetterDocPath((prev) => ({ ...prev, DeleteFilePath: `${imageURLpathCommon}${retrieveData?.agreementLetterDocPath}` }));
        }
    }, [retrieveData, UserId])
    //#endregion


    //#region on change functions
    const handleSelectChange = (name: string, e: any) => {
        setEditDisabled(false);
        setFormError(null);
        if (name === "LocationId") {
            setLocData((loc) => ({
                ...loc,
                ContinentId: e?.ContinentId || 0,
                CountryId: e?.CountryId || 0,
                RegionId: e?.RegionId || 0,
                StateId: e?.StateId || 0
            }))
            setFormValue((form) => ({ ...form, LocationId: e?.value ? Number(e?.value) : 0 }));
        }
        else if (name === "SupplierTypeId") {
            setFormValue((form) => ({ ...form, [name]: e ? e?.map((obj: any) => obj?.value) : [] }));
        }
        else {
            setFormValue((form) => ({ ...form, [name]: e?.value ? Number(e?.value) : 0 }));
        }
    }

    const handleOnChange = (name: string, value: any) => {
        setEditDisabled(false);
        setFormError(null);
        setFormValue((form) => ({ ...form, [name]: value }));
    }

    const handleFileUpload = (name: string, e: any) => {
        const file = e.target.files?.[0];
        const dateCombination = getDateCombination();
        const fileName = dateCombination + '_1_' + (file?.name?.replace(/ /g, "_"))?.replace(/-/g, '');
        const filePath = `${folderPath}/${name}/${fileName}`;
        const path = `${folderPath}/${name}/`;
        const fileSize = (file?.size / 1024) / 1024;
        const length = file?.type?.split('/')?.length
        // const fileType = file?.type?.split('/')?.[length - 1]?.toString()?.toLowerCase();
        const fileType = file?.type

        const fileData: fileUpload = {
            File: file ? file : null,
            FileName: file ? fileName : "",
            FilePath: file ? filePath : "",
            Path: file ? path : "",
            Size: file ? fileSize : 0,
            type: file ? fileType : "",
            needToUpload: true,
        }
        setEditDisabled(file ? false : editDisabled);
        setFormError(null);

        if (name === "IncorprationCertificate") {
            setIncorprationCertificate((prev) => ({ ...prev, ...fileData }));
            setFormValue((form) => ({
                ...form,
                IncorporationCertiPath: fileData?.FilePath
            }))
        }
        else if (name === "PANNoCertificate") {
            setPANNoCertificate((prev) => ({ ...prev, ...fileData }));
            setFormValue((form) => ({
                ...form,
                panDocPath: fileData?.FilePath
            }))
        }
        else if (name === "GSTNCertificate") {
            setGSTNCertificate((prev) => ({ ...prev, ...fileData }));
            setFormValue((form) => ({
                ...form,
                gstnDocPath: fileData?.FilePath
            }))
        }
        else if (name === "AffilitionCertificate") {
            setAffilitionCertificate((prev) => ({ ...prev, ...fileData }));
            setAffiliationsDetails((prev) => ({
                ...prev,
                fileName: fileData?.FileName,
                filePath: fileData?.FilePath
            }))
        }
        else if (name === "ContractFormDocPath") {
            setContractFormDocPath((prev) => ({ ...prev, ...fileData }));
            setFormValue((form) => ({
                ...form,
                ContractFormDocPath: fileData?.FilePath
            }))
        }
        else if (name === "AgreementLetterDocPath") {
            setAgreementLetterDocPath((prev) => ({ ...prev, ...fileData }));
            setFormValue((form) => ({
                ...form,
                AgreementLetterDocPath: fileData?.FilePath
            }))
        }
    }

    const handleServiceCheck = (name: string, e: any) => {
        setEditDisabled(false);
        setFormError(null);
        setFormValue((form) => ({ ...form, [name]: e.target.checked }));
    }

    const handleisActive = (e: any) => {
        if (addbuttontext === 'Save') {
            formValue.IsActive = e
            setActiveId(!activeId)
            setFormError(null);
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e: any) => {
        //setYesNoConfirm(e)
        if (e === true) {
            formValue.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(false);
            setFormError(null);
        }
        setModalShow(false);
    }
    //#endregion

    //#region Affiliations validate/add/remove functions
    const validateAffiliationsData = () => {
        let status = true;
        let error: any = {};

        if (!AffiliationsDetails?.docName && !AffiliationsDetails?.filePath) {
            status = false;
        }

        if (AffiliationsDetails?.filePath && AffilitionCertificate?.File && !isValidPDFFile(AffilitionCertificate?.FileName)) {
            error.AffilitionCertificate = "Only PDF file can be uploaded.";
            status = false;
        }

        setFormError(error);
        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }
        return status;
    }

    const handleAffiliationsAdd = () => {
        if (validateAffiliationsData()) {
            setAffiliationsFileColl((prev) => [...prev, { ...AffilitionCertificate, SeqNo: AffiliationsFileColl?.length + 1 }]);
            setFormValue((form) => ({ ...form, datacollection: [...form?.datacollection, { ...AffiliationsDetails, seqNo: form?.datacollection?.length + 1 }] }))

            setAffilitionCertificate(defaultFileUpload);
            setAffiliationsDetails(defaultAffiliationsDetails);
            if (AffilitionCertificateRef.current !== null) {
                AffilitionCertificateRef.current.value = "";
            }
        }
    }
    const handleAffiliationsRemove = (Id: number) => {
        setEditDisabled(false);
        setFormError(null);
        const removeItem = formValue.datacollection?.find((fin) => fin.seqNo === Id);
        removeItem?.filePath && setAffiliationsDeleteFileColl((prev: any) => ([...prev, removeItem?.filePath && `${imageURLpathCommon}${removeItem?.filePath}`]))
        setAffiliationsFileColl(AffiliationsFileColl?.filter((fil) => fil?.SeqNo !== Id)?.map((obj, index) => { obj.SeqNo = index + 1; return obj }))
        setFormValue((form) => ({ ...form, datacollection: form.datacollection?.filter((fil) => fil?.seqNo !== Id)?.map((obj, index) => { obj.seqNo = index + 1; return obj }) }))
    }
    //#endregion

    //#region check validations
    const validateData = () => {
        let status = true;
        let error: any = {};

        if (formValue?.LocationId <= 0) {
            error.LocationId = "Please select city";
            status = false;
        }
        if (formValue?.SupplierTypeId?.length <= 0) {
            error.SupplierTypeId = "Kindly select the supplier type";
            status = false;
        }
        if (formValue?.HOId <= 0) {
            error.HOId = "Please select State of Incorporation";
            status = false;
        }
        if (formValue?.SupplierName?.trim()?.length <= 0) {
            error.SupplierName = "Please enter Name of the company";
            status = false;
        }

        if (formValue?.SupplierName?.trim()?.length > 0) {
            const isDuplicateSupplierName: any[] = supplierList !== undefined ? supplierList?.filter((element) => element?.supplierId !== formValue?.SupplierId && element?.supplierName?.trim()?.toLowerCase() === formValue?.SupplierName?.trim()?.toLowerCase()) : []
            if (isDuplicateSupplierName?.length > 0) {
                error.SupplierName = "Company name already exist.";
                status = false;
            }
        }
        if (formValue?.OfficeNo?.trim()?.length <= 0) {
            error.OfficeNo = "Please enter office Numbers";
            status = false;
        }
        if (formValue?.OfficeNo && formValue?.OfficeNo?.trim()?.length > 15) {
            error.OfficeNo = "Maximum 15 digits are allowed";
            status = false;
        }
        if (formValue?.BuildingName?.trim()?.length > 50) {
            error.BuildingName = "Maximum 50 characters can be entered.";
            status = false;
        }
        if (formValue?.Street?.trim()?.length <= 0) {
            error.Street = "Please enter street";
            status = false;
        }
        if (formValue?.Street && formValue?.Street?.trim()?.length > 50) {
            error.Street = "Maximum 50 characters can be entered.";
            status = false;
        }
        if (formValue?.Locality?.trim()?.length > 50) {
            error.Locality = "Maximum 50 characters can be entered.";
            status = false;
        }
        if (formValue?.Landmark?.trim()?.length > 50) {
            error.Landmark = "Maximum 50 characters can be entered.";
            status = false;
        }
        if (formValue?.Pincode?.trim()?.length <= 0) {
            error.Pincode = "Please enter pincode";
            status = false;
        }
        if (formValue?.Pincode && formValue?.Pincode?.trim()?.length > 10) {
            error.Pincode = "Maximum 10 digits are allowed.";
            status = false;
        }
        if (formValue?.Website && !validateURL(formValue?.Website)) {
            error.Website = "Only website links can be added here.";
            status = false;
        }

        if (formValue?.IncorporationNo?.trim()?.length > 20) {
            error.IncorporationNo = "Maximum length is 20 characters.";
            status = false;
        }
        if (formValue?.IncorporationCertiPath && IncorprationCertificate?.File && !isValidPDFFile(IncorprationCertificate?.FileName)) {
            error.IncorprationCertificate = "Only PDF file can be uploaded.";
            status = false;
        }
        if (formValue?.PANNo && !isValidPAN(formValue?.PANNo)) {
            error.PANNo = "Please enter Valid PAN Number.";
            status = false;
        }
        if (formValue?.panDocPath && PANNoCertificate?.File && !isValidPDFFile(PANNoCertificate?.FileName)) {
            error.PANNoCertificate = "Only PDF file can be uploaded.";
            status = false;
        }
        if (formValue?.GSTNNo && !isValidGST(formValue?.GSTNNo)) {
            error.GSTNNo = "Please enter Valid GSTN Number.";
            status = false;
        }
        if (formValue?.gstnDocPath && GSTNCertificate?.File && !isValidPDFFile(GSTNCertificate?.FileName)) {
            error.GSTNCertificate = "Only PDF file can be uploaded.";
            status = false;
        }

        // if (formValue?.ContractFormDocPath?.trim()?.length <= 0) {
        //     error.ContractFormDocPath = "Cannot leave blank, input is mandatory.";
        //     status = false;
        // }
        if (formValue.ContractFormDocPath && ContractFormDocPath?.File && !isValidPDFFile(ContractFormDocPath?.FileName)) {
            error.ContractFormDocPath = "Please upload valid document such as PDF only.";
            status = false;
        }
        if (formValue.ContractFormDocPath && ContractFormDocPath?.File && isValidPDFFile(ContractFormDocPath?.FileName) && ContractFormDocPath?.Size > maxFileSize) {
            error.ContractFormDocPath = "Cannot upload file that exceeds 25 MB.";
            status = false;
        }
        // if (formValue.AgreementLetterDocPath?.trim()?.length <= 0) {
        //     error.AgreementLetterDocPath = "Cannot leave blank, input is mandatory.";
        //     status = false;
        // }
        if (formValue.AgreementLetterDocPath && AgreementLetterDocPath?.File && !isValidPDFFile(AgreementLetterDocPath?.FileName)) {
            error.AgreementLetterDocPath = "Please upload valid document such as PDF only.";
            status = false;
        }
        if (formValue.AgreementLetterDocPath && AgreementLetterDocPath?.File && isValidPDFFile(AgreementLetterDocPath?.FileName) && AgreementLetterDocPath?.Size > maxFileSize) {
            error.AgreementLetterDocPath = "Cannot upload file that exceeds 25 MB.";
            status = false;
        }
        if (!formValue?.IsOnline && !formValue?.IsOffline) {
            error.ServiceTypeId = "Cannot leave blank, selection is mandatory.";
            status = false;
        }

        setFormError(error);

        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0]
            // if (id === "ContractFormDocPath") {
            //     ContractFormDocPathRef.current?.focus();
            // }
            // if (id === "AgreementLetterDocPath") {
            //     AgreementLetterDocPathRef.current?.focus();
            // }
            // else {
            // }
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region insert / update data function
    const handleSaveUpdate = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                formValue.SupplierName = formValue?.SupplierName?.trim();
                const insertUpdateSupplier = formValue?.SupplierId > 0 ?
                    await patchUsersData('/midoffice/v1/updatesupplier', formValue)
                    :
                    await postUsersData('/midoffice/v1/insertsupplier', formValue)

                if (insertUpdateSupplier?.status) {

                    if (IncorprationCertificate?.needToUpload) {
                        Promise.allSettled([
                            IncorprationCertificate?.DeleteFilePath && IncorprationCertificate?.DeleteFilePath !== imageURLpathCommon && await handleimageDelete(IncorprationCertificate?.DeleteFilePath),
                            IncorprationCertificate?.Path && await handleimageupload(IncorprationCertificate?.Path, IncorprationCertificate?.FileName, IncorprationCertificate?.File)
                        ])
                    }
                    if (PANNoCertificate?.needToUpload) {
                        Promise.allSettled([
                            PANNoCertificate?.DeleteFilePath && PANNoCertificate?.DeleteFilePath !== imageURLpathCommon && await handleimageDelete(PANNoCertificate?.DeleteFilePath),
                            PANNoCertificate?.Path && await handleimageupload(PANNoCertificate?.Path, PANNoCertificate?.FileName, PANNoCertificate?.File)
                        ])
                    }
                    if (GSTNCertificate?.needToUpload) {
                        Promise.allSettled([
                            GSTNCertificate?.DeleteFilePath && GSTNCertificate?.DeleteFilePath !== imageURLpathCommon && await handleimageDelete(GSTNCertificate?.DeleteFilePath),
                            GSTNCertificate?.Path && await handleimageupload(GSTNCertificate?.Path, GSTNCertificate?.FileName, GSTNCertificate?.File)
                        ])
                    }
                    if (ContractFormDocPath?.needToUpload) {
                        Promise.allSettled([
                            ContractFormDocPath?.DeleteFilePath && ContractFormDocPath?.DeleteFilePath !== imageURLpathCommon && await handleimageDelete(ContractFormDocPath?.DeleteFilePath),
                            ContractFormDocPath?.Path && await handleimageupload(ContractFormDocPath?.Path, ContractFormDocPath?.FileName, ContractFormDocPath?.File)
                        ])
                    }
                    if (AgreementLetterDocPath?.needToUpload) {
                        Promise.allSettled([
                            AgreementLetterDocPath?.DeleteFilePath && AgreementLetterDocPath?.DeleteFilePath !== imageURLpathCommon && await handleimageDelete(AgreementLetterDocPath?.DeleteFilePath),
                            AgreementLetterDocPath?.Path && await handleimageupload(AgreementLetterDocPath?.Path, AgreementLetterDocPath?.FileName, AgreementLetterDocPath?.File)
                        ])
                    }

                    if (AffiliationsDeleteFileColl?.length > 0) {
                        Promise.allSettled([
                            AffiliationsDeleteFileColl?.forEach(async (obj) => {
                                obj && obj !== imageURLpathCommon && await handleimageDelete(obj);
                            })
                        ])
                    }
                    if (AffiliationsFileColl?.length > 0) {
                        Promise.allSettled([
                            AffiliationsFileColl?.forEach(async (obj) => {
                                obj?.needToUpload && obj?.Path && await handleimageupload(obj?.Path, obj?.FileName, obj?.File)
                            })
                        ])
                    }

                    dispatch({ type: 'ALERTINGMESSAGE', message: insertUpdateSupplier?.message || ApiNotRespondMessage, path: "/supplier-list" });
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertUpdateSupplier?.message || ApiNotRespondMessage });
                    dispatch(loaderActions.end());
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }

        }
    }
    //#endregion

    //#region clear function
    const handleClear = () => {
        setFormValue((form) => ({
            ...form,
            LocationId: 0,
            SupplierTypeId: [],
            HOId: 0,
            SupplierName: "",
            OfficeNo: "",
            HouseNo: "",
            BuildingName: "",
            BuildingNo: "",
            Street: "",
            Locality: "",
            Landmark: "",
            Pincode: "",
            Website: "",
            AboutSupplier: "",
            IncorporationNo: "",
            IncorporationCertiPath: "",
            PANNo: "",
            panDocPath: "",
            GSTNNo: "",
            gstnDocPath: "",
            datacollection: [],
            ContractFormDocPath: "",
            AgreementLetterDocPath: "",
            IsOnline: false,
            IsOffline: false,
            IsActive: false,
        }));
        setFormError(null);

        setLocData(defaultLocData);
        setIncorprationCertificate(defaultFileUpload);
        setPANNoCertificate(defaultFileUpload);
        setGSTNCertificate(defaultFileUpload);
        setAffilitionCertificate(defaultFileUpload);
        setContractFormDocPath(defaultFileUpload);
        setAgreementLetterDocPath(defaultFileUpload);

        setAffiliationsDetails(defaultAffiliationsDetails);
        setAffiliationsFileColl([]);
        setActiveId(false);
        setEditDisabled(false);

        if (IncorprationCertificateRef.current !== null) {
            IncorprationCertificateRef.current.value = "";
        }
        if (PANNoCertificateRef.current !== null) {
            PANNoCertificateRef.current.value = "";
        }
        if (GSTNCertificateRef.current !== null) {
            GSTNCertificateRef.current.value = "";
        }
        if (AffilitionCertificateRef.current !== null) {
            AffilitionCertificateRef.current.value = "";
        }
        if (ContractFormDocPathRef.current !== null) {
            ContractFormDocPathRef.current.value = "";
        }
        if (AgreementLetterDocPathRef.current !== null) {
            AgreementLetterDocPathRef.current.value = "";
        }
    }
    //#endregion

    //#region back function
    const handleBack = () => {
        navigate('/supplier-list');
    }
    //#endregion


    return (
        <div className='my-5'>

            <div className="row pb-4">
                {/* {galleryduplicateerrorMessage && <div className="text-danger pb-3 text-center"> {galleryduplicateerrorMessage} </div>} */}
                <div className='col mb-lg-1'>
                    <label htmlFor="inputPassword6" className="col-form-label">Continent</label>
                    <Select
                        className="dropdown select_dropdown custom_class"
                        options={locationsData?.continentData}
                        value={locationsData?.continentData?.filter((fil: any) => fil?.value === locData?.ContinentId)}
                        onChange={(e: any) => handleSelectChange('ContinentId', e)}
                        isDisabled
                    />
                    {/* {cityerrorMessage && <div className="text-danger"> {cityerrorMessage} </div>} */}
                </div>

                <div className='col mb-lg-1'>
                    <label htmlFor="inputPassword6" className="col-form-label">Country</label>
                    <Select
                        className="dropdown select_dropdown custom_class"
                        options={locationsData?.countryData}
                        value={locationsData?.countryData?.filter((fil: any) => fil?.value === locData?.CountryId)}
                        onChange={(e: any) => handleSelectChange('CountryId', e)}
                        isDisabled
                    />
                </div>
                <div className='col mb-lg-1'>
                    <label htmlFor="inputPassword6" className="col-form-label">Region</label>
                    <Select
                        className="dropdown select_dropdown custom_class"
                        options={locationsData?.regionData}
                        value={locationsData?.regionData?.filter((fil: any) => fil?.value === locData?.RegionId)}
                        onChange={(e: any) => handleSelectChange('RegionId', e)}
                        isDisabled
                    />
                </div>

                <div className='col mb-lg-1'>
                    <label htmlFor="inputPassword6" className="col-form-label">State</label>
                    <Select
                        className="dropdown select_dropdown custom_class"
                        options={locationsData?.stateData}
                        value={locationsData?.stateData?.filter((fil: any) => fil?.value === locData?.StateId)}
                        onChange={(e: any) => handleSelectChange('StateId', e)}
                        isDisabled
                    />
                </div>
                <div className='col mb-lg-1'>
                    <label htmlFor="inputPassword6" className="col-form-label required">City</label>
                    <Select
                        inputId='LocationId'
                        className="dropdown select_dropdown custom_class"
                        options={locationsData?.cityData}
                        value={locationsData?.cityData?.filter((fil) => fil?.value === formValue?.LocationId)}
                        onChange={(e: any) => handleSelectChange('LocationId', e)}
                        isDisabled={disabled ? true : false}
                        placeholder="Select City"
                    />
                    {formError?.LocationId && <div className='text-danger fs_14'>{formError.LocationId}</div>}
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-6 col-sm-6 pb-2 '>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">Supplier Type</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <Select
                                inputId='SupplierTypeId'
                                className="dropdown select_dropdown custom_class"
                                options={dropdownData?.SupplierType}
                                value={dropdownData?.SupplierType?.filter((fil) => formValue?.SupplierTypeId?.includes(fil?.value))}
                                onChange={(e: any) => handleSelectChange('SupplierTypeId', e)}
                                isMulti
                                isDisabled={disabled ? true : false}
                                placeholder="Select Supplier Type"
                            />
                            {formError?.SupplierTypeId && <div className='text-danger fs_14'>{formError?.SupplierTypeId}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">State of Incorporation</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <Select className="dropdown select_dropdown custom_class"
                                inputId='HOId'
                                options={dropdownData?.StateofIncorporation}
                                value={dropdownData?.StateofIncorporation?.filter((fil) => fil?.value === formValue?.HOId)}
                                onChange={(e: any) => handleSelectChange('HOId', e)}
                                isDisabled={disabled ? true : false}
                                placeholder="Select State of Incorporation"
                            />
                            {formError?.HOId && <div className='text-danger fs_14'>{formError.HOId}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2 '>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">Name of Company</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input className="form-control"
                                type="text"
                                id='SupplierName'
                                name="SupplierName"
                                value={formValue.SupplierName}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 150 &&
                                        handleOnChange(e.target.name, e.target.value)
                                }}
                                disabled={disabled ? true : false}
                                maxLength={150}
                                placeholder='Company Name'
                            />
                            {formError?.SupplierName && <div className='text-danger fs_14'>{formError.SupplierName}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">Office Number</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="OfficeNo"
                                className="form-control"
                                name='OfficeNo'
                                value={formValue.OfficeNo}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 15 &&
                                        handleOnChange(e.target.name, onlyNumeric(e.target.value))
                                }}
                                disabled={disabled ? true : false}
                                maxLength={15}
                                placeholder='Office Number'
                            />
                            {formError?.OfficeNo && <div className='text-danger fs_14'>{formError.OfficeNo}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Flat/House Number</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="HouseNo"
                                className="form-control"
                                name="HouseNo"
                                value={formValue.HouseNo}
                                onChange={(e: any) =>
                                    e.target.value?.length <= 15 &&
                                    handleOnChange(e.target.name, e.target.value)}
                                disabled={disabled ? true : false}
                                placeholder='Flat/House Number'
                                maxLength={15}
                            />
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Floor/Building Name</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="BuildingName"
                                className="form-control"
                                name="BuildingName"
                                value={formValue.BuildingName}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 50 &&
                                        handleOnChange(e.target.name, e.target.value)
                                }}
                                disabled={disabled ? true : false}
                                maxLength={50}
                                placeholder='Floor/Building Name'
                            />
                            {formError?.BuildingName && <div className='text-danger fs_14'>{formError?.BuildingName}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Floor/Building Number</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="BuildingNo"
                                className="form-control"
                                name="BuildingNo"
                                value={formValue.BuildingNo || ""}
                                onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                disabled={disabled ? true : false}
                                placeholder='Floor/Building Number'
                            />
                            {formError?.BuildingNo && <div className='text-danger fs_14'>{formError?.BuildingNo}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">Colony/Street</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="Street"
                                className="form-control"
                                name='Street'
                                value={formValue.Street}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 50 &&
                                        handleOnChange(e.target.name, e.target.value)
                                }}
                                disabled={disabled ? true : false}
                                maxLength={50}
                                placeholder='Colony/Street'
                            />
                            {formError?.Street && <div className='text-danger fs_14'>{formError?.Street}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Locality</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="Locality"
                                className="form-control"
                                name='Locality'
                                value={formValue.Locality}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 50 &&
                                        handleOnChange(e.target.name, e.target.value)
                                }}
                                disabled={disabled ? true : false}
                                maxLength={50}
                                placeholder='Locality'
                            />
                            {formError?.Locality && <div className='text-danger fs_14'>{formError?.Locality}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Landmark</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="Landmark"
                                className="form-control"
                                name="Landmark"
                                value={formValue.Landmark}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 50 &&
                                        handleOnChange(e.target.name, e.target.value)
                                }}
                                disabled={disabled ? true : false}
                                maxLength={50}
                                placeholder='Landmark'
                            />
                            {formError?.Landmark && <div className='text-danger fs_14'>{formError?.Landmark}</div>}
                        </div>

                    </div>
                </div>
                {/*empty div for row blocking */}
                <div></div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label required">Pincode</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="Pincode"
                                className="form-control"
                                name="Pincode"
                                value={formValue.Pincode}
                                onChange={(e: any) => {
                                    e.target.value?.length <= 10 &&
                                        handleOnChange(e.target.name, onlyNumeric(e.target.value))
                                }}
                                disabled={disabled ? true : false}
                                maxLength={10}
                                placeholder='Pincode'
                            />
                            {formError?.Pincode && <div className='text-danger fs_14'>{formError?.Pincode}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-6 col-sm-6 pb-2'>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Website URL</label>
                        </div>
                        <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                            <input type="text"
                                id="Website"
                                className="form-control"
                                name="Website"
                                value={formValue.Website}
                                onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                disabled={disabled ? true : false}
                                placeholder='Website URL'
                            />
                            {formError?.Website && <div className='text-danger fs_14'>{formError?.Website}</div>}
                        </div>

                    </div>
                </div>
                <div className='col-lg-12 col-sm-12 pb-2'>
                    <div className='row'>
                        <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">About Company</label>
                        </div>
                        <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1 mb-md-2">
                            <textarea className="form-control"
                                id="textAreaExample3"
                                rows={4}
                                name="AboutSupplier"
                                value={formValue.AboutSupplier}
                                onChange={(e: any) => handleOnChange(e.target.name, e.target.value)}
                                disabled={disabled ? true : false}
                                placeholder='About Company'
                            />
                        </div>

                    </div>
                </div>
            </div>

            <div className='row gy-2 pb-2'>
                <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                    <label htmlFor="inputPassword6" className="col-form-label">Incorporation Number</label>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 mb-1">
                    <input type="text"
                        id="IncorporationNo"
                        className="form-control"
                        name="IncorporationNo"
                        value={formValue.IncorporationNo}
                        onChange={(e: any) => {
                            e.target.value?.length <= 20 &&
                                handleOnChange(e.target.name, e.target.value)
                        }}
                        disabled={disabled ? true : false}
                        maxLength={20}
                        placeholder='Incorporation Number'
                    />
                    {formError?.IncorporationNo && <div className='text-danger fs_14'>{formError?.IncorporationNo}</div>}
                </div>
                <div className="col-lg-5 col-md-3 col-sm-11 mb-lg-1 mb-md-1">
                    <FileField
                        ref={IncorprationCertificateRef}
                        id="IncorprationCertificate"
                        accept={acceptance}
                        onChange={(e: any) => handleFileUpload("IncorprationCertificate", e)}
                        disabled={disabled}
                    />
                    {formValue?.IncorporationCertiPath && <div title={formValue?.IncorporationCertiPath?.split("/")?.pop()} className="text-truncate fs_14"> {formValue?.IncorporationCertiPath?.split("/")?.pop()} </div>}
                    {formError?.IncorprationCertificate && <div className='text-danger fs_14'>{formError?.IncorprationCertificate}</div>}
                </div>
                {/* <div className="col-lg-1 col-md-1 col-sm-1 mb-lg-1 mb-md-1">
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd">Add</button>
                </div> */}

                {/* PAN No */}
                <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                    <label htmlFor="inputPassword6" className="col-form-label">PAN Number</label>
                </div>
                <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">
                    <input type="text"
                        id="PANNo"
                        className="form-control"
                        name="PANNo"
                        value={formValue.PANNo}
                        onChange={(e: any) => {
                            e.target.value?.length <= 10 &&
                                handleOnChange(e.target.name, e.target.value)
                        }}
                        disabled={disabled ? true : false}
                        maxLength={10}
                        placeholder='PAN Number'
                    />
                    {formError?.PANNo && <div className='text-danger fs_14'>{formError?.PANNo}</div>}
                </div>
                <div className="col-lg-5 col-md-3 col-sm-11 mb-lg-1 mb-md-1">
                    <FileField
                        ref={PANNoCertificateRef}
                        id="PANNoCertificate"
                        accept={acceptance}
                        onChange={(e: any) => handleFileUpload("PANNoCertificate", e)}
                        disabled={disabled}
                    />
                    {formValue?.panDocPath && <div title={formValue?.panDocPath?.split("/")?.pop()} className="text-truncate fs_14"> {formValue?.panDocPath?.split("/")?.pop()} </div>}
                    {formError?.PANNoCertificate && <div className='text-danger fs_14'>{formError?.PANNoCertificate}</div>}
                </div>
                {/* <div className="col-lg-1 col-md-1 col-sm-1 mb-lg-1 mb-md-1">
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd">Add</button>
                </div> */}

                {/* GSTN No */}
                <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                    <label htmlFor="inputPassword6" className="col-form-label">GSTN Number</label>
                </div>
                <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">
                    <input type="text"
                        id="GSTNNo"
                        className="form-control"
                        name="GSTNNo"
                        value={formValue.GSTNNo}
                        onChange={(e: any) => {
                            e.target.value?.length <= 15 &&
                                handleOnChange(e.target.name, e.target.value?.toUpperCase())
                        }}
                        disabled={disabled ? true : false}
                        maxLength={15}
                        placeholder='GSTN Number'
                    />
                    {formError?.GSTNNo && <div className='text-danger fs_14'>{formError?.GSTNNo}</div>}
                </div>
                <div className="col-lg-5 col-md-3 col-sm-11 mb-lg-1 mb-md-1">
                    <FileField
                        ref={GSTNCertificateRef}
                        id="GSTNCertificate"
                        accept={acceptance}
                        onChange={(e: any) => handleFileUpload("GSTNCertificate", e)}
                        disabled={disabled}
                    />
                    {formValue?.gstnDocPath && <div title={formValue?.gstnDocPath?.split("/")?.pop()} className="text-truncate fs_14"> {formValue?.gstnDocPath?.split("/")?.pop()} </div>}
                    {formError?.GSTNCertificate && <div className='text-danger fs_14'>{formError?.GSTNCertificate}</div>}
                </div>
                {/* <div className="col-lg-1 col-md-1 col-sm-1 mb-lg-1 mb-md-1">
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd">Add</button>
                </div> */}
                {/* Affiliations */}
                <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                    <label htmlFor="inputPassword6" className="col-form-label">Affiliations</label>
                </div>
                <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">
                    <input type="text"
                        id="Affiliations"
                        name='Affiliations'
                        className="form-control"
                        value={AffiliationsDetails?.docName}
                        onChange={(e: any) => {
                            setEditDisabled(false);
                            setFormError(null);
                            e.target.value?.length <= 100 &&
                                setAffiliationsDetails((prev) => ({ ...prev, docName: e.target.value }));
                        }}
                        disabled={disabled ? true : false}
                        placeholder='Affiliations'
                        maxLength={100}
                    />
                </div>
                <div className="col-lg-5 col-md-3 col-sm-11 mb-lg-1 mb-md-1">
                    <FileField
                        ref={AffilitionCertificateRef}
                        id="AffilitionCertificate"
                        accept={acceptance}
                        onChange={(e: any) => handleFileUpload("AffilitionCertificate", e)}
                        disabled={disabled}
                    />
                    {formError?.AffilitionCertificate && <div className='text-danger fs_14'>{formError?.AffilitionCertificate}</div>}
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1 mb-lg-1 mb-md-1">
                    <button type="button" className="btn btn-primary mx-1" onClick={handleAffiliationsAdd}>Add</button>
                </div>
            </div>

            {
                formValue.datacollection &&
                formValue.datacollection?.map((obj, index) => {
                    return (
                        <div key={`affiliation${obj.seqNo}${index + 1}`} className="row gy-2 pb-2">
                            <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1"></div>
                            <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">
                                <input type="text"
                                    className="form-control"
                                    value={obj?.docName}
                                    onChange={(e: any) => setAffiliationsDetails((prev) => ({ ...prev, docName: e.target.value }))}
                                    disabled
                                />
                            </div>
                            <div className="col-lg-5 col-md-3 col-sm-11 mb-lg-1 mb-md-1">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className={`form-control btn_add `}
                                        value={obj?.fileName || ""}
                                        disabled
                                    />
                                    <label
                                        className="browser_file_filed position-absolute top-0 end-0 h-100  align-items-center px-3 border-start"
                                        style={{ minWidth: '80px', cursor: 'pointer' }}
                                    >
                                        Browse
                                    </label>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-1 col-sm-1 mb-lg-1 mb-md-1">
                                <button type="button" className="btn btn-primary mx-1" onClick={() => handleAffiliationsRemove(obj?.seqNo)}>  &times; </button>
                            </div>
                        </div>
                    )
                })
            }

            <div className='row'>
                <div className="col-sm-6 col-12">
                    <div className="row  gy-2">
                        <div className="col-lg-6 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Contract Form</label>
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                            <FileField
                                ref={ContractFormDocPathRef}
                                id="ContractFormDocPath"
                                accept={acceptance}
                                onChange={(e: any) => handleFileUpload("ContractFormDocPath", e)}
                                disabled={disabled}
                            />
                            {formValue?.ContractFormDocPath && <div title={formValue?.ContractFormDocPath?.split("/")?.pop()} className="text-truncate fs_14"> {formValue?.ContractFormDocPath?.split("/")?.pop()} </div>}
                            {formError?.ContractFormDocPath && <div className='text-danger fs_14'>{formError?.ContractFormDocPath}</div>}
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Agreement Letter</label>
                        </div>
                        <div className="col-lg-6 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                            <FileField
                                ref={AgreementLetterDocPathRef}
                                id="AgreementLetterDocPath"
                                accept={acceptance}
                                onChange={(e: any) => handleFileUpload("AgreementLetterDocPath", e)}
                                disabled={disabled}
                            />
                            {formValue?.AgreementLetterDocPath && <div title={formValue?.AgreementLetterDocPath?.split("/")?.pop()} className="text-truncate fs_14"> {formValue?.AgreementLetterDocPath?.split("/")?.pop()} </div>}
                            {formError?.AgreementLetterDocPath && <div className='text-danger fs_14'>{formError?.AgreementLetterDocPath}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 col-12">
                    <div className='row'>
                        <div className="col-lg-3 col-md-4 col-sm-12 mb-lg-1 mb-md-1">
                            <label className="col-form-label required">Service Type</label>
                        </div>
                        <div className="col-lg-8 col-md-4 col-sm-12 mb-lg-1 mb-md-1 d-flex justify-content-center align-items-center">
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="Online"
                                    checked={formValue.IsOnline}
                                    onChange={(e) => handleServiceCheck("IsOnline", e)}
                                    disabled={disabled ? true : false}

                                />
                                <label className="form-check-label" htmlFor="Online">Online</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="Offline"
                                    checked={formValue.IsOffline}
                                    onChange={(e) => handleServiceCheck("IsOffline", e)}
                                    disabled={disabled ? true : false}
                                />
                                <label className="form-check-label" htmlFor="Offline">Offline</label>
                            </div>
                        </div>
                        {formError?.ServiceTypeId && <div className='text-danger text-center fs_14'>{formError?.ServiceTypeId}</div>}
                    </div>
                </div>


                <div className="mb-1 gy-2 col-lg-12">
                    <div className='row'>
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-lg-1">
                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                        </div>
                        <div className=" col-lg-2 col-md-6 col-sm-6 mb-lg-1 mb-md-1">
                            <Switch
                                onChange={handleisActive}
                                checked={activeId}
                                className="react-switch"
                                disabled={disabled ? true : false}
                            />
                        </div>
                        <ConfirmationModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            noconfirm={() => handleConfirmation(false)}
                            yesconfirm={() => handleConfirmation(true)}
                        />

                    </div>
                </div>
            </div>

            <div className="mt-3 d-flex justify-content-center">

                <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled} > {addbuttontext} </button>
                <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClear} disabled={disabled || cleardisable} >Clear</button>
                <button type="button" className="btn btn-primary mx-1" id="btnBack" onClick={handleBack} >Back</button>
            </div>

        </div>
    )
}

export default SupplierProfile